import request from '../utils/request'

const API_PREFIX = '/api/tiku/v1'

export function getMe() {
  return request({
    url: `${API_PREFIX}/me`,
    method: 'get',
  })
}

export function getGatewayMe() {
  return request({
    url: '/bff/me',
    method: 'get',
  })
}

export function getAppUsers() {
  return request({
    url: '/v1/app-users',
    method: 'get',
  })
}

export function getPlat() {
  return request({ url: `${API_PREFIX}/plat`, method: 'get' })
}

export function getCourses(params) {
  return request({ url: `${API_PREFIX}/courses`, method: 'get', params })
}

export function getQuestions(data, params) {
  return request({ url: `${API_PREFIX}/questions/search`, method: 'post', data, params })
}

export function updateQuestions(data) {
  return request({ url: `${API_PREFIX}/questions/${data.id}`, method: 'post', data })
}

export function delQuestions(data) {
  return request({ url: `${API_PREFIX}/questions/${data.id}`, method: 'delete' })
}

export function createQuestions(data) {
  return request({ url: `${API_PREFIX}/questions`, method: 'post', data })
}

export function getUserList() {
  return request({ url: `${API_PREFIX}/user`, method: 'get' })
}

export function updateUserLimit(id, data) {
  return request({ url: `${API_PREFIX}/user/${id}/limit`, method: 'post', data })
}

export function getLogList(params) {
  return request({ url: `${API_PREFIX}/logs`, method: 'get', params })
}

export function applyRequest(data) {
  return request({ url: `${API_PREFIX}/requests/apply`, method: 'post', data })
}

export function getRequests(params) {
  return request({ url: `${API_PREFIX}/requests`, method: 'get', params })
}

export function approveRequest(id) {
  return request({ url: `${API_PREFIX}/requests/${id}/approve`, method: 'post' })
}

export function rejectRequest(id) {
  return request({ url: `${API_PREFIX}/requests/${id}/reject`, method: 'post' })
}

export function getQuota() {
  return request({ url: `${API_PREFIX}/user/quota`, method: 'get' })
}

export function getAuditLogs(params) {
  return request({ url: `${API_PREFIX}/audit-logs`, method: 'get', params })
}

export function getUserSettings() {
  return request({ url: `${API_PREFIX}/user/settings`, method: 'get' })
}

export function updateUserSettings(data) {
  return request({ url: `${API_PREFIX}/user/settings`, method: 'post', data })
}

export function getRequestLogs(params) {
  return request({ url: `${API_PREFIX}/request-logs`, method: 'get', params })
}

export function getRequestStats(params) {
  return request({ url: `${API_PREFIX}/request-logs/stats`, method: 'get', params })
}

export function getProviders() {
  return request({ url: `${API_PREFIX}/providers`, method: 'get' })
}

export function createProvider(data) {
  return request({ url: `${API_PREFIX}/providers`, method: 'post', data })
}

export function updateProvider(id, data) {
  return request({ url: `${API_PREFIX}/providers/${id}`, method: 'post', data })
}

export function deleteProvider(id) {
  return request({ url: `${API_PREFIX}/providers/${id}`, method: 'delete' })
}

export function getPricing() {
  return request({ url: `${API_PREFIX}/pricing`, method: 'get' })
}

export function createPricing(data) {
  return request({ url: `${API_PREFIX}/pricing`, method: 'post', data })
}

export function updatePricing(id, data) {
  return request({ url: `${API_PREFIX}/pricing/${id}`, method: 'post', data })
}

export function deletePricing(id) {
  return request({ url: `${API_PREFIX}/pricing/${id}`, method: 'delete' })
}

export function getSearchOrders() {
  return request({ url: `${API_PREFIX}/search-orders`, method: 'get' })
}

export function getSystemConfig() {
  return request({ url: `${API_PREFIX}/system-config`, method: 'get' })
}

export function updateSystemConfig(data) {
  return request({ url: `${API_PREFIX}/system-config`, method: 'post', data })
}

export function getNotebooks(params) {
  return request({ url: `${API_PREFIX}/notebooks`, method: 'get', params })
}

export function createNotebook(data) {
  return request({ url: `${API_PREFIX}/notebooks`, method: 'post', data })
}

export function deleteNotebook(id) {
  return request({ url: `${API_PREFIX}/notebooks/${id}`, method: 'delete' })
}

export function startNotebook(id) {
  return request({ url: `${API_PREFIX}/notebooks/${id}/start`, method: 'post' })
}

export function stopNotebook(id) {
  return request({ url: `${API_PREFIX}/notebooks/${id}/stop`, method: 'post' })
}

export function addNotebookItems(id, data) {
  return request({ url: `${API_PREFIX}/notebooks/${id}/items`, method: 'post', data })
}

export function getNotebookItems(id, params) {
  return request({ url: `${API_PREFIX}/notebooks/${id}/items`, method: 'get', params })
}

export function deleteNotebookItems(id, data) {
  return request({ url: `${API_PREFIX}/notebooks/${id}/items`, method: 'delete', data })
}

export function exportNotebook(id, params) {
  return request({ url: `${API_PREFIX}/notebooks/${id}/export`, method: 'get', params, responseType: 'blob' })
}
